module.exports = __webpack_public_path__ + "static/media/Poop-Happy-Blink.a8b36bce.png";